/* istanbul ignore file */
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const PurchaseOrderHeader = () => (
  <EntityHeader entityTitle={data => data.getValueBySource('id')} defaultAuthor={DEFAULT_ENTITY_AUTHOR} />
);

export default PurchaseOrderHeader;
